import React from 'react';

import { matchCreateConsolidationRoutePath } from '@futrli/shared-services';

import { ConsolidationContext } from '../consolidation-context/consolidation-context';
import { CreateConsolidation } from '../create-consolidation/create-consolidation';
import { ConsolidationWizardContextProvider } from '../consolidation-wizard-context/consolidation-wizard-context';
import { EditConsolidation } from '../edit-consolidation/edit-consolidation';

export const ConsolidationWrapper = () => {
  return (
    <ConsolidationContext>
      {matchCreateConsolidationRoutePath(location.pathname) ? (
        <ConsolidationWizardContextProvider>
          <CreateConsolidation />
        </ConsolidationWizardContextProvider>
      ) : (
        <EditConsolidation />
      )}
    </ConsolidationContext>
  );
};
